<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-3
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.status') }}
          b-form-select(v-model="isEnable" :disabled="loading" size="sm" @change="getOperatorMiniGameList")
            option(:value="null") {{ $t('ui.all') }}
            option(:value="true") {{ $t('ui.enabled') }}
            option(:value="false") {{ $t('ui.disabled') }}
      .form-group.col-4
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            i.fa.fa-search
          DebounceInput(autofocus type="text" v-model="gameName" :placeholder="$t('message.search_by_game_name')" @enter="getOperatorMiniGameList" size="sm")

      .form-group.col-5.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getOperatorMiniGameList()"
          variant="primary"
          size="sm"
        )
      .form-group.col-12.mb-1
        div {{ $t('message.actionPerformWillReflectProd') }}
  .card-body
    .row
      .col-12
        .clusterize-scroll
          .table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
              thead.thead-light
                tr
                  th.text-center(width="3%")
                    span #
                  th(width="8%")
                    span(:title="$t('ui.game_type')") {{ $t('ui.game_type') }}
                  th(width="10%")
                    span(:title="$t('ui.game_name')") {{ $t('ui.game_name') }}
                  th.text-right(width="6%")
                    span(:title="$t('ui.token_request')") {{ $t('ui.token_request') }}
                  th.text-center(width="10%")
                    span(:title="$t('ui.max_game_reward')") {{ $t('ui.max_game_reward') }}
                  th.text-center(width="10%")
                    span(:title="$t('ui.max_chance_per_day')") {{ $t('ui.max_chance_per_day') }}
                  th.text-center(width="6%")
                    span(:title="$t('ui.is_recurring_chance')") {{ $t('ui.is_recurring_chance') }}
                  th.text-center(width="6%")
                    span(:title="$t('ui.status')") {{ $t('ui.status') }}
                  th.text-center(width="5%")
                    span(:title="$t('ui.payout_method')" ) {{ $t('ui.payout_method') }}
                  th.text-right(width="10%")
                    span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                  th.text-center(width="7%")
                    span(:title="$t('ui.action')") {{ $t('ui.action') }}
              tbody
                tr(v-if="miniGameOpList.length == 0")
                  td(colspan="12").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in miniGameOpList")
                  td.text-center
                    span(:title="index + 1") {{ index + 1 }}
                  td
                    span(:title="item.game_type.toUpperCase()") {{ item.game_type.toUpperCase() }}
                  td
                    span(:title="item.game_name") {{ item.game_name }}
                  td.text-right
                    span.font-weight-bold(:class="$helpers.fontClassName(item.token_request)" :title="item.token_request") {{ item.token_request }}
                  td.text-center.font-weight-bold
                    span(:title="item.max_game_reward") {{ item.max_game_reward }}
                  td.text-center.font-weight-bold
                    template(v-if="item.max_chance_per_day != null")
                      span(:title="item.max_chance_per_day") {{ item.max_chance_per_day }}
                    template(v-else)
                      span(:title="$t('ui.unlimited')") {{ $t('ui.unlimited')}}
                  td.text-center
                    span
                      i(style="font-size: 14px;" :class="{'fas fa-check-circle text-success': item.is_recurring_chance, 'fas fa-times-circle text-warning': !item.is_recurring_chance  }")
                  td.text-center
                    span
                      i(style="font-size: 14px;" :class="{'fas fa-check-circle text-success': item.status, 'fas fa-times-circle text-warning': !item.status  }")
                  td.text-center
                    span(:title="$t('ui.' + item.payout_method.toLowerCase())") {{ $t("ui." + item.payout_method.toLowerCase()) }}
                    template(v-if="['INBOX'].includes(item.payout_method)")
                      br
                      span.small(:title="item.campaign_id") {{ item.campaign_id }}
                  td.text-right
                    span(:title="item.created_by") {{ item.created_by }}
                    br
                    span(:title="$moment(item.created_on).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_on).format('YYYY-MM-DD, HH:mm:ss') }}
                  td.text-center
                    .d-inline-block.mx-1.my-1(v-if="isEditAccess && item.available_edit")
                      a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                        href="javascript:void(0)"
                        @click="onUpdate(item)"
                        :title="$t('ui.update')"
                        )
                    .d-inline-block.mx-1.my-1
                      a.fas.fa-crown.btn.btn-ssm.btn-icon.btn-success(
                        href="javascript:void(0)"
                        @click="onUpdateMiniGameReward(item)"
                        :title="$t('ui.reward')"
                        )

      editminigameop(ref="editminigameop" :item="editSelectedMiniGameOp" @clicked="afterUpdate" @failed="handleFailed")
      minigamerewardop(ref="minigamerewardop" :item="editSelectedMiniGameOp" @failed="handleFailed")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import editminigameop from "@/components/siteeditor/miniGame/editMiniGameOp.vue";
import minigamerewardop from "@/components/siteeditor/miniGame/miniGameRewardOp.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    editminigameop,
    DebounceInput,
    minigamerewardop
  },
  props: {
    siteId: {
      type: Number
    },
    siteInfo: {
      type: Array
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      miniGameOpList: [],
      editSelectedMiniGameOp: null,
      gameName: '',
      isEnable: null
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_minigameop");
    }
  },
  mounted() {
    this.getOperatorMiniGameList();
  },
  methods: {
    getOperatorMiniGameList: function() {
      let url = config.getOperatorMiniGameListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        game_name: this.gameName,
        enable: this.isEnable
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.ds != null) {
                  this.miniGameOpList = response.data.ds.operator_games;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
    onUpdate(item) {
      this.editSelectedMiniGameOp = item;
      this.$refs.editminigameop.$refs.editMiniGameOp.show();
    },
    onUpdateMiniGameReward(item) {
      this.editSelectedMiniGameOp = item;
      this.$refs.minigamerewardop.$refs.miniGameRewardOp.show();
    },
    afterUpdate: function() {
      this.getOperatorMiniGameList()
      this.$helpers.showDialog(this.$t("ui.combine.edit_mini_game"), this.$t("message.success"), "success");
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
    }
  }
};
</script>